

















































import Vue from 'vue';
import moment from 'moment';
import * as math from 'mathjs';
// import { ProgressChartBarData } from '@/store/interfaces/ProgressChartBarData';
import { ProgressChartModel } from './ProgressChartModel';
import { getDefaultChartConfiguration } from './ProgressChartConfiguration';

const calcTrackerValue = ({ startTime, stopTime, targetValue }: {
startTime: string; stopTime: string; targetValue: number;
}): number => {
  // TODO make this take start, end, current
  const TIME_FORMAT = 'HH:mm';

  let mStart = moment(startTime, [TIME_FORMAT]);
  if (!mStart.isValid()) {
    mStart = moment().startOf('day');
  }
  let mEnd = moment(stopTime, [TIME_FORMAT]);
  if (!mEnd.isValid()) {
    mEnd = moment().endOf('day');
  }

  let trackerValue = 0;
  if (moment().isAfter(mStart)) {
    const mNow = moment();
    const totalSecs = moment.duration(mEnd.diff(mStart)).asSeconds();
    const mUsedEnd = mNow.isAfter(mEnd) ? mEnd : mNow;
    const usedSecs = moment.duration(mUsedEnd.diff(mStart)).asSeconds();
    const pct = usedSecs / totalSecs;
    trackerValue = Math.round(pct * targetValue * 100) / 100;
  }

  return trackerValue;
};

const createChart = (ctx: HTMLCanvasElement, labels: string[]): ProgressChartModel => {
  const options = getDefaultChartConfiguration();
  options.data.labels = labels;
  options.data.datasets[0].data = [];
  options.data.datasets[1].data = [];
  options.data.datasets[2].data = [];
  return new ProgressChartModel(ctx, options);
};

export default Vue.extend({
  name: 'ProgressChart',
  props: {
    msg: {
      type: String,
      default: '',
    }
  },
  data: function () {
    return {
      barData: {
        label: 'Today',
        currentValue: '0',
        targetValue: '3000',
        trackerValue: 0,
        startTime: '00:00',
        stopTime: '23:59',
      },
      progressChart: null as unknown as ProgressChartModel,
      timer: 0,
    };
  },
  computed: {
    computedTargetValue: function (): number {
      return math.evaluate(this.barData.targetValue);
    },
    computedCurrentValue: function (): number {
      return math.evaluate(this.barData.currentValue);
    }
  },
  mounted: function () {
    const chartEl = this.$el.querySelector('#progress-chart-canvas') as HTMLCanvasElement;

    this.progressChart = createChart(chartEl, [this.barData.label]);

    const updateChart = (): void => {
      clearTimeout(this.timer);
      this.timer = setTimeout(updateChart, 1000);

      this.progressChart.datasetCurrent.data = [this.computedCurrentValue];
      this.progressChart.datasetTarget.data = [this.computedTargetValue];
      this.progressChart.datasetTracker.data = [calcTrackerValue(
        {
          startTime: this.barData.startTime,
          stopTime: this.barData.stopTime,
          targetValue: this.computedTargetValue
        })];
      this.progressChart.chart.update();
    };
    updateChart();
  },
  beforeDestroy: function () {
    clearTimeout(this.timer);
    this.progressChart.chart.destroy();
  }
});

